export { DetailsOfExpensesReport } from '@app/pages/Analytics/DetailsOfExpensesReport/ui';
